// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".с-message-template-validate-hint__text{font-weight:500;font-size:16px;line-height:115%;color:var(--text--l2);width:100%;max-width:299px;margin:16px auto;text-align:center}@media(min-width: 768px){.с-message-template-validate-hint__text{margin-bottom:24px}}", ""]);
// Exports
module.exports = exports;
